import { useRecordContext } from "react-admin";

const CustomImageField = () => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  // Prefer the source image: thumbnail → first entry's preserved original → first asset.
  // After sync runs, entries[0].assets[0] is the SMALLEST webp variant, so we fall back
  // to assetOriginal first to show admins their original upload at full quality.
  const url =
    record.thumbnail?.url ||
    record.entries?.[0]?.assetOriginal?.url ||
    record.entries?.[0]?.assets?.[0]?.url;

  if (!url) {
    return null;
  }

  const alt = record.name || "Image";

  return <img src={url} alt={alt} style={{ maxHeight: 60, maxWidth: 100 }} />;
};

export default CustomImageField;
